import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui-wrapper";
import { CloseIcon, IconButton, PlusIcon } from "@flat-ui";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { setFilterMenuAnchorPosition, setIsFilterMenuOpen, setOriginalColumnPreferences } from "@store/table/table-slice";
import { useRef } from "react";

/**
 * Props for FaroTableColumnVisibilityMenuIcon.
 *
 * @property columnPreferences - The current map of column preferences,
 * including visibility, order, and sort state for each column. Used to determine which columns
 * are visible and to snapshot preferences when opening the menu.
 */

/**
 * Fixed width (in pixels) of the column visibility menu.
 * Used to calculate the anchor position of the menu relative to the trigger button.
 */
const MENU_WIDTH = 210;

/**
 * Renders the icon button that triggers the column visibility menu for the table.
 * Displays a plus icon when the menu is closed and a close icon when the menu is open.
 * The button is right-aligned and dispatches an action to open the menu on click.
 */
export function FaroTableColumnVisibilityMenuIcon(t0) {
  const $ = _c(12);
  const {
    columnPreferences
  } = t0;
  const dispatch = useAppDispatch();
  const {
    isOpen
  } = useAppSelector(_temp);
  const buttonRef = useRef(null);
  let t1;
  if ($[0] !== dispatch) {
    t1 = function updateAnchorPosition() {
      if (buttonRef.current) {
        const rect = buttonRef.current.getBoundingClientRect();
        const top = rect.bottom + window.scrollY;
        const left = rect.left + window.scrollX - MENU_WIDTH;
        dispatch(setFilterMenuAnchorPosition({
          top,
          left
        }));
      }
    };
    $[0] = dispatch;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const updateAnchorPosition = t1;
  let t2;
  if ($[2] !== columnPreferences || $[3] !== dispatch || $[4] !== updateAnchorPosition) {
    t2 = function handleOpenMenu() {
      dispatch(setIsFilterMenuOpen(true));
      dispatch(setOriginalColumnPreferences(columnPreferences));
      updateAnchorPosition();
    };
    $[2] = columnPreferences;
    $[3] = dispatch;
    $[4] = updateAnchorPosition;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleOpenMenu = t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "flex",
      justifyContent: "flex-end",
      width: "100%"
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== isOpen) {
    t4 = isOpen ? <CloseIcon /> : <PlusIcon />;
    $[7] = isOpen;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== handleOpenMenu || $[10] !== t4) {
    t5 = <Box sx={t3}><IconButton size="s" margin={0.5} onClick={handleOpenMenu} ref={buttonRef}>{t4}</IconButton></Box>;
    $[9] = handleOpenMenu;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
function _temp(state) {
  return state.table.filterMenu;
}